module.exports = __webpack_public_path__ + "img/top-right.aa72619e.png";